// extracted by mini-css-extract-plugin
export default {"box":"ExternalAddressView_box__E6g+r"};